import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Box,
  Chip,
} from "@mui/material";
import { useEffect } from "react";
import GoogleNews from "./News";

export default function NewsCard({
  image,
  date,
  title,
  onClick,
  tabName,
  originCountries,
  destinationCountry,
}) {
  // const oceanFreightQuery = "Sea Freight";
  // const keywordGroups
  //   const oceanFreightQuery= [
  //   "Sea Freight OR Ocean Freight OR Container Shipping",
  //   "Container Freight Rates OR Spot Rates OR Rate Volatility",
  //   "Port Congestion OR Panama Canal OR Red Sea Shipping",
  //   "Transpacific Shipping OR Asia Europe Freight OR Intra Asia Freight",
  //   // add more groups until all 60 keywords are covered
  // ];
  // const oceanFreightQuery = [
  //   `"Sea Freight"|"Ocean Freight"|"Container Shipping"`,
  //   `"Container Freight Rates"|"Spot Rates"|"Rate Volatility"`,
  //   `"Port Congestion"|"Panama Canal"|"Red Sea Shipping"`,
  //   `"Transpacific Shipping"|"Asia Europe Freight"|"Intra Asia Freight"`,
  // ];

  // const tariffQuery = [
  //   `"Tariff hike"|"Import tariff"|"Custom duty"`,
  //   `"Anti-Dumping Duty"|"Countervailing Duty"|"Safeguard Duty"`,
  //   `"Trade tariff policy"|"Preferential Tariff Agreement"|"Finance Ministry tariff"`,
  // ];
  const oceanFreightQuery = [
    "(Sea Freight OR Ocean Freight OR Container Shipping) when:1d",
    "(Container Freight Rates OR Spot Rates OR Rate Volatility) when:1d",
    "(Port Congestion OR Panama Canal OR Red Sea Shipping) when:1d",
    "(Transpacific Shipping OR Asia Europe Freight OR Intra Asia Freight) when:7d",
  ];

  const tariffQuery = [
    "(Tariff hike OR Import tariff OR Custom duty) when:7d",
    "(Anti-Dumping Duty OR Countervailing Duty OR Safeguard Duty) when:7d",
    "(Trade tariff policy OR Preferential Tariff Agreement OR Finance Ministry tariff) when:7d",
  ];

  const fuelQuery = [
    "(Fuel price increase OR OPEC production decision OR Energy cost inflation) when:7d",
    "(Red Sea oil shipping risk OR VLSFO bunker price OR VLSFO ) when:7d",
    "(MGO  OR MGO vs VLSFO price OR scrubber fuel spread) when:7d",
  ];

  const query =
    tabName === "Ocean Freight"
      ? oceanFreightQuery
      : tabName === "Fuel"
        ? fuelQuery
        : tariffQuery;

  function buildKeywords(keywords, originCountries, destinationCountry) {
    const origins = Array.isArray(originCountries)
      ? originCountries
      : [originCountries];

    return keywords.flatMap((keyword) =>
      origins.map((origin) => `${keyword} ${origin} ${destinationCountry}`),
    );
  }

  const finalKeywords = buildKeywords(
    query,
    originCountries,
    destinationCountry,
  );

  // const tariffQuery = [];

  return (
    <Card
      sx={{
        borderRadius: 2,
        overflow: "hidden",
        boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
        cursor: "pointer",
        // padding:2,
        margin: 2,
      }}
      onClick={onClick}
    >
      {/* Image Section */}
      <Box sx={{ position: "relative" }}>
        {/* <GoogleNews query={query} /> */}
        <GoogleNews
          query={finalKeywords}
          originCountries={originCountries}
          destinationCountry={destinationCountry}
        />

        {/* <CardMedia component="img" height="140" image={image} alt={title} /> */}

        {/* Date Badge */}
        {/* <Chip
          label={date}
          size="small"
          sx={{
            position: "absolute",
            borderRadius: 1,
            top: 8,
            left: 8,
            background: "#0f172a",
            color: "#fff",
            fontSize: 12,
          }}
        /> */}
      </Box>

      {/* Content */}
      {/* <CardContent sx={{ pb: 2 }}>
        <Typography
          variant="body2"
          sx={{
            color: "#4b5563",
            lineHeight: 1.4,
            mb: 1,
          }}
        >
          {title}
        </Typography>

        <Typography
          variant="body2"
          sx={{
            color: "#2563eb",
            fontWeight: 500,
            display: "flex",
            alignItems: "center",
            gap: 0.5,
          }}
        >
          Read more →
        </Typography>
      </CardContent> */}
    </Card>
  );
}
